import { multipartRequest } from "../../api/API"

export const login =(data)=>{
    return multipartRequest.post('/login/',data)
}